import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import { events } from "#utilities/js/lightboxes/lightbox.js"
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { open } = events

const onOpen = object(listener, {
  type: open,
  passive,
  task: (
    opener,
    { detail: modal }
  ) => {
    const { ownerDocument } = opener

    for (const rsrc of all('[type="hidden"][name="new_rsrc[]"]', ownerDocument)) {
      const { value } = rsrc
      const item = one(`button[value="${value}"]`, modal)

      if (item) {
        const li = closest('li', item)

        if (li) {
          remove(li)
        }
      }
    }
  }
})

export default button => {
  onOpen.listen(button)
}
